// components/DocumentEditor/ImageUpload/DropIndicator.jsx
import React from 'react';

/**
 * Visual indicator shown during image drag operations
 * Shows a blinking vertical line where the image will be inserted
 */
const DropIndicator = ({ 
  visible, 
  position = null, 
  isDragOver = false,
  isValidFile = true 
}) => {
  if (!visible) return null;

  const indicatorStyle = position ? {
    position: 'absolute',
    top: position.y - 10,
    left: position.x,
    zIndex: 1000,
    pointerEvents: 'none'
  } : {};

  return (
    <div 
      className={`transition-all duration-200 ${visible ? 'opacity-100' : 'opacity-0'}`}
      style={indicatorStyle}
    >
      {/* Blinking vertical line */}
      <div 
        className={`w-0.5 h-8 transition-all duration-200 ${
          isValidFile 
            ? 'bg-blue-500 animate-pulse' 
            : 'bg-red-500 animate-pulse'
        }`}
        style={{
          animation: isValidFile ? 'blink 1s infinite' : 'blink-red 1s infinite'
        }}
      >
      </div>
      
      {/* Add custom keyframes for blinking animation */}
      <style jsx>{`
        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0.3; }
        }
        
        @keyframes blink-red {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
};

export default DropIndicator;